import { render, staticRenderFns } from "./RewardLogList.vue?vue&type=template&id=5b22e38f&scoped=true&"
import script from "./RewardLogList.vue?vue&type=script&lang=js&"
export * from "./RewardLogList.vue?vue&type=script&lang=js&"
import style0 from "./RewardLogList.vue?vue&type=style&index=0&id=5b22e38f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22e38f",
  null
  
)

export default component.exports